export default {
  draggable: {y: true},
  hoverable: true,
  resizable: false,
  fullWidth: true,
  selectable: true,
  preserveAspectRatio: true,
};
